const TARGET_GROUPS = [
  "Familien",
  "Gruppen",
  "Firmen",
  "Events",
  "Hotelgäste",
  "Tourismus",
  "Competition",
  "Gemischt",
];

const TIMELINES = ["Sofort", "1–3 Monate", "3–6 Monate", "6–12 Monate", "Offen"];

function Select({ label, name, value, onChange, options, testId }) {
  return (
    <div>
      <label className="field-label">{label}</label>
      <select
        value={value}
        onChange={(e) => onChange(name, e.target.value)}
        className="field"
        data-testid={testId}
      >
        <option value="">Bitte wählen</option>
        {options.map((opt) => (
          <option key={opt} value={opt}>{opt}</option>
        ))}
      </select>
    </div>
  );
}

export default function LeadFormSharedFields({ data, set }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
      <Select
        label="Zielgruppe"
        name="target_group"
        value={data.target_group}
        onChange={set}
        options={TARGET_GROUPS}
        testId="select-target-group"
      />
      <Select
        label="Zeitplan"
        name="timeline"
        value={data.timeline}
        onChange={set}
        options={TIMELINES}
        testId="select-timeline"
      />
    </div>
  );
}
